export enum IImageStylePreset {
  "default" = "default",
  "logo" = "logo",
  "cover" = "cover",
  "galleryThumbnail" = "galleryThumbnail",
  "galleryImage" = "galleryImage",
}

export interface IImageStyle {
  style: IImageStylePreset;
  url: string;
}

export interface IImage {
  imageStyles?: IImageStyle[];
  description?: string;
  previewURL?: string;
}
